import React, { useState, useEffect } from 'react';

export const Header: React.FC = () => {
    const [scrolled, setScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleNavClick = (e: React.MouseEvent<HTMLElement>, targetId: string) => {
        e.preventDefault();
        setIsMobileMenuOpen(false); // Cerrar menú suavemente

        if (targetId === 'top') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            const element = document.getElementById(targetId);
            if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
            }
        }
    };

    const navItems = [
        { name: 'Inicio', target: 'top' },
        { name: 'Últimas Noticias', target: 'noticias' },
        { name: 'PlayStation', target: 'playstation' },
        { name: 'Xbox', target: 'xbox' },
        { name: 'Nintendo', target: 'nintendo' },
        { name: 'General', target: 'general' }
    ];

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled || isMobileMenuOpen
                ? 'bg-[#0f172a] border-b border-white/5 py-3 shadow-lg shadow-blue-900/5'
                : 'bg-transparent py-6'
                }`}
        >
            <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
                {/* LOGO */}
                <div
                    className="flex items-center gap-2 cursor-pointer z-50 relative"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                    <img src="/logo.png" alt="gamesNewsJR Logo" className="w-10 h-10 object-contain" />
                    <span className="text-xl font-bold tracking-tight text-white">
                        games<span className="text-slate-400 font-light">JR</span>
                    </span>
                </div>

                {/* Desktop Navigation */}
                <nav className="hidden md:flex gap-8">
                    {navItems.map((item) => (
                        <a
                            key={item.name}
                            href={`#${item.target}`}
                            onClick={(e) => handleNavClick(e, item.target)}
                            className="text-sm font-medium text-slate-300 hover:text-white transition-colors relative group cursor-pointer"
                        >
                            {item.name}
                            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-500 transition-all duration-300 group-hover:w-full"></span>
                        </a>
                    ))}
                </nav>

                {/* Desktop Juegos Button */}
                <div className="hidden md:block">
                    <button
                        onClick={(e) => handleNavClick(e, 'juegos')}
                        className="bg-white/10 hover:bg-white/20 text-white text-sm font-medium py-2 px-4 rounded-full border border-white/5 backdrop-blur-md transition-all duration-300 hover:scale-105 active:scale-95"
                    >
                        Juegos
                    </button>
                </div>

                {/* Mobile Hamburger Button */}
                <button
                    className="md:hidden z-50 text-white p-2 relative focus:outline-none"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    {/* Animación del ícono hamburguesa a X */}
                    <div className="w-6 h-6 flex flex-col justify-center items-center gap-1.5">
                        <span className={`block w-full h-0.5 bg-white transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                        <span className={`block w-full h-0.5 bg-white transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
                        <span className={`block w-full h-0.5 bg-white transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                    </div>
                </button>

                {/* --- MENÚ MÓVIL CON ANIMACIÓN --- */}
                {/* Ya no usamos {isMobileMenuOpen &&}, sino clases CSS para ocultar/mostrar */}
                <div 
                    className={`fixed inset-0 z-40 bg-[#0f172a] flex flex-col items-center justify-center transition-all duration-500 ease-in-out
                    ${isMobileMenuOpen 
                        ? 'opacity-100 visible translate-y-0'  // Estado Abierto
                        : 'opacity-0 invisible -translate-y-10' // Estado Cerrado (se va hacia arriba)
                    }`}
                >
                    <nav className="flex flex-col items-center gap-8">
                        {navItems.map((item, index) => (
                            <a
                                key={item.name}
                                href={`#${item.target}`}
                                onClick={(e) => handleNavClick(e, item.target)}
                                // Agregamos un pequeño delay a cada elemento para un efecto cascada
                                style={{ transitionDelay: isMobileMenuOpen ? `${index * 50}ms` : '0ms' }}
                                className={`text-2xl font-bold text-slate-200 hover:text-blue-500 transition-all duration-500 transform 
                                ${isMobileMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                            >
                                {item.name}
                            </a>
                        ))}
                        <button
                            onClick={(e) => handleNavClick(e, 'juegos')}
                            className={`mt-4 bg-blue-600 text-white text-lg font-bold py-3 px-8 rounded-full hover:bg-blue-500 transition-all duration-500 delay-300 transform
                            ${isMobileMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                        >
                            Juegos
                        </button>
                    </nav>
                </div>
            </div>
        </header>
    );
};